import type { RouteRecordRaw, Router } from 'vue-router'

const PrisonersRoutes: RouteRecordRaw = {
  path: '/registration/prisoners',
  children: [
    {
      path: '',
      name: 'PrisonersView',
      component: () => import('./views/PrisonersListView.vue'),
      meta: {
        title: 'prisoners.prisonerDonations',
      },
    },
    {
      path: 'create',
      name: 'CreatePrisonerView',
      component: () => import('./views/PrisonersUpsertView.vue'),
      meta: {
        title: 'prisoners.createViewRouteTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:prisonerId',
      name: 'EditPrisonerView',
      component: () => import('./views/PrisonersUpsertView.vue'),
      meta: {
        title: 'prisoners.editViewRouteTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:prisonerId',
      name: 'PrisonersSingleView',
      component: () => import('./views/PrisonersSingleView.vue'),
      meta: {
        title: 'prisoners.singleViewRouteTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PrisonersRoutes)
}
